module.exports = __webpack_public_path__ + "file.png?44feb3e0ca654420dd64c9d26aac392a";